<template>
  <InitialAvatarImage
    class="instrument-avatar"
    :image="symbolPreffix"
    :size="size"
    alt=""
  >
    <template #fallback>
      <InstrumentAvatarFallback
        :instrument-type="instrumentType"
        :instrument-symbol="symbol"
        :size="size"
      />
    </template>
  </InitialAvatarImage>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { InitialAvatarImage } from '@warrenbrasil/nebraska-web';
import { InstrumentAvatarFallback } from '@/modules/trade/components/InstrumentAvatarFallback';

import { getInstrumentSymbolPreffix } from '@/modules/trade/helpers/instruments';
import { InstrumentType } from '@/modules/trade/types/bff';

interface Props {
  size: string;
  symbol: string;
  instrumentType?: InstrumentType;
}
const props = defineProps<Props>();

const symbolPreffix = computed(() => {
  return getInstrumentSymbolPreffix(props.symbol);
});
</script>

<style lang="less" scoped></style>
